import { render } from "./DateChange.vue?vue&type=template&id=50b68f4e"
import script from "./DateChange.vue?vue&type=script&lang=js"
export * from "./DateChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__